(function () {
  /* LOCKED DESKTOP BASELINE — RB 7/10/26 V1 Pre-Mobile.
     Do not edit for mobile. Mobile uses rb-reviews-home.js. */
  function isDesktopReviewsViewport() {
    return window.matchMedia('(min-width: 1000px)').matches;
  }
  if (!isDesktopReviewsViewport()) return;

  var YOTPO_APP_KEY = 'Ioh4q2i1hYPxfsXa70UJV30ezP7GCp6PGQluCzib';
  var REVIEWS_FETCH_COUNT = 30;
  var THUMB_MIN_WIDTH = 56;
  var yotpoWidgetsInitRequested = false;

  function killReadyReviewCarousels() {
    document.querySelectorAll('.rb-reviews__yotpo').forEach(function (el) {
      if (typeof el._rbKillYotpoMotion === 'function') {
        el._rbKillYotpoMotion();
      }
    });
  }

  function patchYotpoInitOnce() {
    if (window._rbYotpoInitPatched) return;
    window._rbYotpoInitPatched = true;

    var poll = window.setInterval(function () {
      if (!window.yotpo) return;
      window.clearInterval(poll);

      if (typeof window.yotpo.initWidgets === 'function') {
        var originalInit = window.yotpo.initWidgets.bind(window.yotpo);
        window.yotpo.initWidgets = function () {
          var result = originalInit.apply(window.yotpo, arguments);
          window.setTimeout(killReadyReviewCarousels, 0);
          window.setTimeout(killReadyReviewCarousels, 400);
          window.setTimeout(killReadyReviewCarousels, 1500);
          return result;
        };
      }

      if (Array.isArray(window.yotpo.callbacks)) {
        window.yotpo.callbacks.push(killReadyReviewCarousels);
      }
    }, 100);
  }

  patchYotpoInitOnce();

    function refreshRbReviewsYotpo() {
    if (yotpoWidgetsInitRequested) return;
      if (!window.yotpo || typeof window.yotpo.initWidgets !== 'function') return;
    yotpoWidgetsInitRequested = true;
      window.yotpo.initWidgets();
    }

  function initRbReviewsRoot(root) {
    if (!root) return;
    if (root.dataset.rbReviewsNative === 'true') return;
    if (root.dataset.rbReviewsRootInit === '1') return;
    root.dataset.rbReviewsRootInit = '1';

    var GAP = 18;
    var AUTOPLAY_MS = 5000;
    var ANIMATION_MS = 450;
    var resizeTimer;
    var autoplayTimer;
    var userDragging = false;
    var lastLogicalIndex = 0;

    function getState(el) {
      if (!el._rbCarouselState) {
        el._rbCarouselState = {
          index: 0,
          step: 0,
          slideWidth: 0,
          perView: 1,
          gap: GAP,
          animating: false,
        };
      }
      return el._rbCarouselState;
    }

    function perViewFor(width) {
      if (width >= 900) return 4;
      if (width >= 640) return 2;
      return 1;
    }

    function getTrack(el) {
      return el.querySelector('.glide__track');
    }

    function getSlidesEl(el) {
      return el.querySelector('.glide__slides');
    }

    function getRealSlides(el) {
      return el.querySelectorAll('.glide__slide:not(.glide__slide--clone)');
    }

    function trackWidth(el) {
      var track = getTrack(el);
      if (!track) return 0;
      /* clientWidth avoids subpixel round-up that clips the last card border */
      return track.clientWidth || Math.round(track.getBoundingClientRect().width);
    }

    function getCarouselMetrics(el) {
      var width = trackWidth(el);
      var perView = perViewFor(width);
      if (!width || !perView) return null;

      var totalGap = GAP * (perView - 1);
      /* −1px so the furthest-right card border isn’t clipped by overflow:hidden */
      var slideWidth = Math.floor((width - totalGap - 1) / perView);
      if (slideWidth < 1) return null;

      return {
        perView: perView,
        trackWidth: width,
        gap: GAP,
        slideWidth: slideWidth,
        step: slideWidth + GAP,
      };
    }

    function getMaxIndex(el) {
      var metrics = getCarouselMetrics(el);
      if (!metrics) return 0;
      return Math.max(0, getRealSlides(el).length - metrics.perView);
    }

    function getWrap(el) {
      return el.closest('.rb-reviews__yotpo-wrap');
    }

    function getScrollbarEls(el) {
      var wrap = getWrap(el);
      if (!wrap) return null;
      return {
        bar: wrap.querySelector('[data-rb-reviews-scrollbar]'),
        track: wrap.querySelector('[data-rb-reviews-track]'),
        thumb: wrap.querySelector('[data-rb-reviews-thumb]'),
      };
    }

    function canShowScrollbar(el) {
      var metrics = getCarouselMetrics(el);
      if (!metrics) return false;
      /* Wait for expanded API slides — Yotpo's initial ~7 slides make the thumb look massive */
      if (el.dataset.rbReviewsExpanded !== '1') return false;
      return getRealSlides(el).length > metrics.perView;
    }

    function hideScrollbarBar(ui) {
      if (!ui || !ui.bar) return;
      ui.bar.hidden = true;
      ui.bar.setAttribute('hidden', '');
      ui.bar.removeAttribute('data-rb-scrollbar-ready');
      if (ui.thumb) {
        ui.thumb.style.width = '';
        ui.thumb.style.transform = 'translate3d(0, 0, 0)';
      }
    }

    function revealScrollbarBar(ui) {
      if (!ui || !ui.bar) return;
      ui.bar.hidden = false;
      ui.bar.removeAttribute('hidden');
      ui.bar.style.setProperty('display', 'block', 'important');
      ui.bar.style.setProperty('visibility', 'visible', 'important');
      ui.bar.setAttribute('data-rb-scrollbar-ready', '1');
    }

    function getScrollbarTrackWidth(el, ui) {
      if (ui && ui.track) {
        var measured = Math.round(ui.track.getBoundingClientRect().width);
        if (measured > 0) return measured;
      }

      var carouselTrackWidth = trackWidth(el);
      if (carouselTrackWidth > 0) return carouselTrackWidth;

      var wrap = getWrap(el);
      if (wrap) {
        var wrapWidth = Math.round(wrap.getBoundingClientRect().width);
        if (wrapWidth > 0) return wrapWidth;
      }

      return 0;
    }

    function getScrollbarMetrics(el, index) {
      var ui = getScrollbarEls(el);
      if (!ui || !ui.track || !ui.thumb) return null;

      var metrics = getCarouselMetrics(el);
      if (!metrics) return null;

      var slideCount = getRealSlides(el).length;
      var maxIndex = Math.max(0, slideCount - metrics.perView);
      var trackWidthPx = getScrollbarTrackWidth(el, ui);
      if (!trackWidthPx) return null;

      var thumbWidth = Math.max(
        THUMB_MIN_WIDTH,
        Math.round(trackWidthPx * (metrics.perView / Math.max(slideCount, 1)))
      );
      var maxOffset = Math.max(0, trackWidthPx - thumbWidth);
      var progress = maxIndex > 0 ? index / maxIndex : 0;
      var offset = Math.max(0, Math.min(1, progress)) * maxOffset;

      return {
        ui: ui,
        thumbWidth: thumbWidth,
        offset: offset,
      };
    }

    function updateScrollbar(el, index, animate) {
      var ui = getScrollbarEls(el);
      if (!ui || !ui.bar || !ui.track || !ui.thumb) return;

      if (!canShowScrollbar(el)) {
        hideScrollbarBar(ui);
        return;
      }

      var data = getScrollbarMetrics(el, index);
      if (!data) {
        /* Keep hidden until track/slides are measurable — avoids a full-width flash */
        hideScrollbarBar(ui);
        return;
      }

      ui.track.style.setProperty('width', '100%', 'important');
      /* Size thumb BEFORE reveal so first paint is already correct */
      data.ui.thumb.style.width = data.thumbWidth + 'px';

      var nextTransform = 'translate3d(' + data.offset + 'px, 0, 0)';
      if (animate) {
        /* Set transition only when target changes — avoids restart stutter */
        if (data.ui.thumb.style.transform !== nextTransform) {
          data.ui.thumb.style.transition =
            'transform ' + (ANIMATION_MS / 1000) + 's cubic-bezier(0.22, 0.61, 0.36, 1)';
          data.ui.thumb.style.transform = nextTransform;
        }
      } else {
        data.ui.thumb.style.transition = 'none';
        data.ui.thumb.style.transform = nextTransform;
      }

      revealScrollbarBar(ui);
    }

    function syncScrollbar(el, index, animate) {
      updateScrollbar(el, index, animate);
      /* Remeasure after layout paints — first pass can use a stale track width */
      window.requestAnimationFrame(function () {
        updateScrollbar(el, index, animate);
        window.requestAnimationFrame(function () {
          updateScrollbar(el, index, animate);
        });
      });
      window.setTimeout(function () {
        updateScrollbar(el, index, animate);
      }, 120);
    }

    function clearScrollbarTransition(el) {
      var ui = getScrollbarEls(el);
      if (!ui || !ui.thumb) return;
      ui.thumb.style.transition = 'none';
    }

    function destroyYotpoMotion(el) {
      el.querySelectorAll('.glide, .glide__track').forEach(function (node) {
        node.style.setProperty('transform', 'none', 'important');
        node.style.setProperty('transition', 'none', 'important');
        node.removeAttribute('data-glide-el');
      });

      el.querySelectorAll('[data-glide-dir], .glide__arrow, .glide__bullets, .glide__bullet').forEach(function (node) {
        node.remove();
      });

      el.querySelectorAll('.glide__slide--clone').forEach(function (clone) {
        clone.remove();
      });

      el.querySelectorAll('.glide').forEach(function (glideRoot) {
        var keys = [];
        try {
          keys = Object.getOwnPropertyNames(glideRoot);
        } catch (error) {
          keys = [];
        }
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var instance = glideRoot[key];
          if (!instance || typeof instance !== 'object') continue;
          if (typeof instance.go !== 'function' && typeof instance.mount !== 'function') continue;

          instance.go = function () {};
          instance.mount = function () {};
          instance.update = function () {};
          instance.run = function () {};
          if (typeof instance.pause === 'function') instance.pause();
          if (typeof instance.disable === 'function') {
            try {
              instance.disable();
            } catch (error) {
              /* Glide builds vary */
            }
          }
          if (instance.settings) {
            instance.settings.autoplay = 0;
            instance.settings.hoverpause = false;
            instance.settings.swipeThreshold = false;
            instance.settings.animationDuration = 0;
          }
        }
      });
    }

    function freezeGlide(el) {
      destroyYotpoMotion(el);
    }

    function readSlidesTranslateX(slidesEl) {
      if (!slidesEl) return 0;
      var transform = window.getComputedStyle(slidesEl).transform;
      if (!transform || transform === 'none') return 0;
      return Math.round(new DOMMatrixReadOnly(transform).m41);
    }

    function markTransformWrite(el) {
      el._rbSuppressTransformLock = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          el._rbSuppressTransformLock = false;
        });
      });
    }

    function markSettleCooldown(el) {
      el._rbSettleUntil = Date.now() + 600;
    }

    function isInSettleCooldown(el) {
      return el._rbSettleUntil && Date.now() < el._rbSettleUntil;
    }

    function applySlideLayout(el) {
      var slides = getRealSlides(el);
      var slidesEl = getSlidesEl(el);
      var track = getTrack(el);
      var metrics = getCarouselMetrics(el);
      if (!slides.length || !slidesEl || !track || !metrics) return null;

      var state = getState(el);
      state.perView = metrics.perView;
      state.gap = metrics.gap;
      state.slideWidth = metrics.slideWidth;
      state.step = metrics.step;

      el.style.setProperty('--rb-review-slide-width', metrics.slideWidth + 'px');
      el.style.setProperty('--rb-reviews-carousel-gap', metrics.gap + 'px');

      track.style.setProperty('width', '100%', 'important');
      track.style.setProperty('max-width', '100%', 'important');
      track.style.setProperty('overflow', 'hidden', 'important');
      track.style.setProperty('box-sizing', 'border-box', 'important');
      track.style.setProperty('margin', '0', 'important');
      track.style.setProperty('padding', '0', 'important');

      slidesEl.style.setProperty('display', 'flex', 'important');
      slidesEl.style.setProperty('flex-direction', 'row', 'important');
      slidesEl.style.setProperty('direction', 'ltr', 'important');
      slidesEl.style.setProperty('gap', '0', 'important');
      slidesEl.style.setProperty('margin', '0', 'important');
      slidesEl.style.setProperty('padding', '0', 'important');
      slidesEl.style.setProperty('width', 'max-content', 'important');
      slidesEl.style.setProperty('box-sizing', 'border-box', 'important');
      slidesEl.style.setProperty('transform-origin', 'left center', 'important');
      slidesEl.style.setProperty('will-change', 'transform', 'important');

      slides.forEach(function (slide, index) {
        slide.style.setProperty('width', metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('min-width', metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('max-width', metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('flex', '0 0 ' + metrics.slideWidth + 'px', 'important');
        slide.style.setProperty('flex-shrink', '0', 'important');
        slide.style.setProperty('flex-grow', '0', 'important');
        slide.style.setProperty('margin', '0', 'important');
        slide.style.setProperty('padding', '0', 'important');
        slide.style.setProperty('box-sizing', 'border-box', 'important');
        slide.style.setProperty('overflow', 'hidden', 'important');
        slide.style.setProperty(
          'margin-right',
          index < slides.length - 1 ? metrics.gap + 'px' : '0',
          'important'
        );
      });

      return metrics;
    }

    function getOffsetForIndex(el, index) {
      var state = getState(el);
      if (state.step > 0) {
        return Math.round(index * state.step);
      }
      var metrics = getCarouselMetrics(el);
      return metrics ? Math.round(index * metrics.step) : 0;
    }

    function setSlidesTransform(el, index, animate, options) {
      options = options || {};
      var slidesEl = getSlidesEl(el);
      var state = getState(el);
      if (!slidesEl || !state.step) return;

      if (options.freezeGlide) {
        freezeGlide(el);
      }

      var offset = getOffsetForIndex(el, index);

      if (animate) {
        state.animating = true;
        slidesEl.style.setProperty(
          'transition',
          'transform ' + (ANIMATION_MS / 1000) + 's linear',
          'important'
        );
      } else {
        state.animating = false;
        slidesEl.style.setProperty('transition', 'none', 'important');
      }

      markTransformWrite(el);
      slidesEl.style.setProperty(
        'transform',
        'translate3d(' + (-offset) + 'px, 0px, 0px)',
        'important'
      );
    }

    function clearSlidesTransition(el) {
      var slidesEl = getSlidesEl(el);
      if (!slidesEl) return;
      slidesEl.style.setProperty('transition', 'none', 'important');
    }

    function isTransformAligned(el, index) {
      var expected = -getOffsetForIndex(el, index);
      var current = readSlidesTranslateX(getSlidesEl(el));
      return Math.abs(current - expected) <= 1;
    }

    function setActiveSlide() {
      /* Yotpo listens to active slide changes — do not toggle Glide classes. */
    }

    function revertExternalTransform(el) {
      var slidesEl = getSlidesEl(el);
      if (!slidesEl || isTransformAligned(el, lastLogicalIndex)) return;
      destroyYotpoMotion(el);
      clearSlidesTransition(el);
      markTransformWrite(el);
      slidesEl.style.setProperty(
        'transform',
        'translate3d(' + (-getOffsetForIndex(el, lastLogicalIndex)) + 'px, 0px, 0px)',
        'important'
      );
    }

    function goToIndex(el, targetIndex, animate) {
      var metrics = applySlideLayout(el);
      if (!metrics) return;

      var maxIndex = getMaxIndex(el);
      targetIndex = Math.max(0, Math.min(maxIndex, Math.round(targetIndex)));
      lastLogicalIndex = targetIndex;
      getState(el).index = targetIndex;

      setSlidesTransform(el, targetIndex, animate, { freezeGlide: !animate });
      syncScrollbar(el, targetIndex, animate);

      if (animate) {
        var settled = false;
        var slidesEl = getSlidesEl(el);

        function settle() {
          if (settled) return;
          settled = true;
          if (slidesEl) {
            slidesEl.removeEventListener('transitionend', onTransitionEnd);
          }
          getState(el).animating = false;
          markSettleCooldown(el);
          clearSlidesTransition(el);
          clearScrollbarTransition(el);
          destroyYotpoMotion(el);
          queueAutoplay(el);
        }

        function onTransitionEnd(event) {
          if (!slidesEl || event.target !== slidesEl || event.propertyName !== 'transform') return;
          settle();
        }

        if (slidesEl) {
          slidesEl.addEventListener('transitionend', onTransitionEnd);
        }
        window.setTimeout(settle, ANIMATION_MS + 100);
      }
    }

    function advanceCarousel(el) {
      if (getState(el).animating) return;

      var maxIndex = getMaxIndex(el);
      if (maxIndex === 0) return;

      if (lastLogicalIndex >= maxIndex) {
        goToIndex(el, 0, false);
        queueAutoplay(el, AUTOPLAY_MS);
        return;
      }

      goToIndex(el, lastLogicalIndex + 1, true);
    }

    function layoutCarousel(el) {
      var maxIndex = getMaxIndex(el);
      if (lastLogicalIndex > maxIndex) {
        lastLogicalIndex = maxIndex;
      }
      goToIndex(el, lastLogicalIndex, false);
      lockReviewCards(el);
    }

    function queueAutoplay(el, delayMs) {
      if (el.dataset.rbAutoplay !== '1') return;
      if (autoplayTimer) window.clearTimeout(autoplayTimer);
      autoplayTimer = window.setTimeout(function () {
        if (el.dataset.rbAutoplay !== '1') return;
        if (el.dataset.rbCarouselReady !== '1') {
          queueAutoplay(el, delayMs || AUTOPLAY_MS);
          return;
        }
        if (userDragging || getState(el).animating) {
          queueAutoplay(el, 250);
          return;
        }
        advanceCarousel(el);
      }, typeof delayMs === 'number' ? delayMs : AUTOPLAY_MS);
    }

    function startAutoplay(el) {
      if (el.dataset.rbAutoplay === '1') return;
      el.dataset.rbAutoplay = '1';
      queueAutoplay(el, AUTOPLAY_MS);
    }

    function stopAutoplay(el) {
      el.dataset.rbAutoplay = '0';
      if (autoplayTimer) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function takeControl(el) {
      destroyYotpoMotion(el);
      lockCarouselInteraction(el);
      lastLogicalIndex = 0;
      getState(el).index = 0;

      var slidesEl = getSlidesEl(el);
      if (slidesEl) {
        slidesEl.setAttribute('data-rb-owns-motion', 'true');
      }

      el._rbKillYotpoMotion = function () {
        destroyYotpoMotion(el);
      };

      layoutCarousel(el);
      el.dataset.rbCarouselReady = '1';
      fixReviewTextEntities(el);
      syncScrollbar(el, lastLogicalIndex, false);
      startAutoplay(el);
      bindTransformLock(el);

      if (el._rbYotpoKillTimer) window.clearInterval(el._rbYotpoKillTimer);
      el._rbYotpoKillTimer = window.setInterval(function () {
        if (el.dataset.rbCarouselReady !== '1') return;
        destroyYotpoMotion(el);
      }, 1500);
    }

    function bindTransformLock(el) {
      if (el.dataset.rbTransformLock === '1') return;
      var slidesEl = getSlidesEl(el);
      if (!slidesEl) return;
      el.dataset.rbTransformLock = '1';

      new MutationObserver(function () {
        if (el._rbSuppressTransformLock) return;
        if (getState(el).animating) return;
        if (isInSettleCooldown(el)) return;
        if (el.dataset.rbCarouselReady !== '1') return;
        revertExternalTransform(el);
      }).observe(slidesEl, { attributes: true, attributeFilter: ['style'] });
    }

    function getHeaderSummaryEls(el) {
      var container = el.closest('.rb-container');
      if (!container) return null;
      return {
        summary: container.querySelector('[data-rb-reviews-summary]'),
        count: container.querySelector('[data-rb-reviews-header-count]'),
      };
    }

    function formatReviewCount(total) {
      return total.toLocaleString('en-US') + ' Reviews';
    }

    function updateReviewSummary(el, total) {
      var header = getHeaderSummaryEls(el);
      if (!header || !header.summary || !header.count || !total) return;
      header.count.textContent = formatReviewCount(total);
      header.summary.hidden = false;
    }

    function lockReviewCards(el) {
      el.querySelectorAll('.reviews-carousel-card-container').forEach(function (card) {
        card.removeAttribute('data-rb-card-scrollbar');
        card.style.setProperty('pointer-events', 'none', 'important');
        card.style.setProperty('overflow-x', 'hidden', 'important');
        card.style.setProperty('overflow-y', 'hidden', 'important');
        card.style.setProperty('touch-action', 'none', 'important');
        card.style.setProperty('user-select', 'none', 'important');
        card.style.setProperty('-webkit-user-select', 'none', 'important');
        card.style.setProperty('overscroll-behavior', 'none', 'important');
        card.style.setProperty('scrollbar-width', 'none', 'important');

        card.querySelectorAll('*').forEach(function (child) {
          child.style.setProperty('pointer-events', 'none', 'important');
          child.style.setProperty('user-select', 'none', 'important');
          child.style.setProperty('-webkit-user-select', 'none', 'important');
          child.style.setProperty('scrollbar-width', 'none', 'important');
        });

        /* Clip review text only — leave product image/title alone */
        card.querySelectorAll('.review-content, .content-review, .rb-review-card__body').forEach(function (node) {
          node.style.setProperty('overflow', 'hidden', 'important');
          node.style.setProperty('overflow-y', 'hidden', 'important');
          node.style.setProperty('overflow-x', 'hidden', 'important');
        });

        card.querySelectorAll(
          '.reviews-carousel-card-review-product-container, .rb-review-card__product'
        ).forEach(function (node) {
          node.style.removeProperty('overflow');
          node.style.removeProperty('overflow-y');
          node.style.removeProperty('overflow-x');
          node.style.removeProperty('max-height');
          node.style.removeProperty('display');
        });
      });

      el.querySelectorAll('.reviews-carousel-card-container a, .review-product').forEach(function (link) {
        link.style.setProperty('pointer-events', 'none', 'important');
        link.style.setProperty('cursor', 'default', 'important');
      });

      fixReviewTextEntities(el);
    }

    function lockCarouselInteraction(el) {
      if (el.dataset.rbCarouselLocked === '1') {
        lockReviewCards(el);
        return;
      }
      el.dataset.rbCarouselLocked = '1';

      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('touch-action', 'none', 'important');
      el.style.setProperty('user-select', 'none', 'important');

      el.querySelectorAll('.glide, .glide__track, .glide__slides, .glide__slide, .yotpo-widget-instance, .yotpo-reviews-carousel-widget-container').forEach(function (node) {
        node.style.setProperty('pointer-events', 'none', 'important');
        node.style.setProperty('touch-action', 'none', 'important');
        node.style.setProperty('user-select', 'none', 'important');
      });

      var wrap = getWrap(el);
      if (wrap) {
        wrap.style.setProperty('pointer-events', 'none', 'important');
        wrap.style.setProperty('touch-action', 'none', 'important');
      }

      lockReviewCards(el);
    }

    function getProductId(root) {
      var widget = root.querySelector('[data-yotpo-product-id]');
      return widget && widget.dataset.yotpoProductId ? widget.dataset.yotpoProductId : '';
    }

    function getReviewsApiUrl(productId) {
      var base = 'https://api.yotpo.com/v1/widget/' + YOTPO_APP_KEY;
      if (productId) {
        return base + '/products/' + encodeURIComponent(productId) + '/reviews.json';
      }
      return base + '/reviews.json';
    }

    function formatReviewDate(isoDate) {
      if (!isoDate) return '';
      var date = new Date(isoDate);
      if (isNaN(date.getTime())) return '';
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var year = String(date.getFullYear()).slice(-2);
      return month + '/' + day + '/' + year;
    }

    function decodeHtmlEntities(value) {
      if (value == null || value === '') return '';
      var decoded = String(value);
      if (decoded.indexOf('&') === -1) return decoded;

      var previous;
      var guard = 0;
      do {
        previous = decoded;
        var textarea = document.createElement('textarea');
        textarea.innerHTML = decoded;
        decoded = textarea.value;
        guard++;
      } while (decoded !== previous && decoded.indexOf('&') !== -1 && guard < 3);

      return decoded;
    }

    function fixReviewTextEntities(el) {
      el.querySelectorAll(
        '.review-title, .review-content, .reviewer-display-name, .review-product-name'
      ).forEach(function (node) {
        var text = node.textContent;
        if (!text || text.indexOf('&') === -1) return;
        var decoded = decodeHtmlEntities(text);
        if (decoded !== text) {
          node.textContent = decoded;
        }
      });
    }

    function buildProductMap(products) {
      var map = {};
      (products || []).forEach(function (product) {
        map[product.id] = product;
      });
      return map;
    }

    function updateStarRating(slide, score) {
      var stars = slide.querySelectorAll('.yotpo-star-container svg');
      var filledCount = Math.min(5, Math.max(0, Math.round(Number(score) || 5)));
      for (var i = 0; i < stars.length; i++) {
        var path = stars[i].querySelector('path');
        if (path) {
          /* style + important beats the CSS default fill so empty stars can be white */
          path.style.setProperty('fill', i < filledCount ? '#e7721b' : '#ffffff', 'important');
          path.style.setProperty('stroke', '#e7721b', 'important');
        }
      }
    }

    function populateSlide(slide, review, productMap, isProductPage) {
      var nameEl = slide.querySelector('.reviewer-display-name');
      var statusEl = slide.querySelector('.reviewer-status');
      var dateEl = slide.querySelector('.review-date');
      var titleEl = slide.querySelector('.review-title');
      var contentEl = slide.querySelector('.review-content');
      var productWrap = slide.querySelector('.reviews-carousel-card-review-product-container');
      var product = productMap[review.product_id];

      if (nameEl) {
        nameEl.textContent = decodeHtmlEntities(
          review.user && review.user.display_name ? review.user.display_name : 'Verified Customer'
        );
      }
      if (statusEl) {
        statusEl.style.visibility = review.verified_buyer ? 'visible' : 'hidden';
      }
      if (dateEl) {
        dateEl.textContent = formatReviewDate(review.created_at);
      }
      if (titleEl) {
        titleEl.textContent = decodeHtmlEntities(review.title || '');
      }
      if (contentEl) {
        contentEl.textContent = decodeHtmlEntities(review.content || '');
      }

      var card = slide.querySelector('.reviews-carousel-card-container');
      if (card) {
        card.removeAttribute('data-rb-card-scrollbar');
        card.style.setProperty('pointer-events', 'none', 'important');
        card.style.setProperty('overflow-y', 'hidden', 'important');
        card.style.setProperty('overflow-x', 'hidden', 'important');
        card.style.setProperty('touch-action', 'none', 'important');
      }

      updateStarRating(slide, review.score || 5);

      if (productWrap) {
        if (isProductPage || !product) {
          productWrap.style.display = 'none';
      } else {
          productWrap.style.display = '';
          var productImage = productWrap.querySelector('.review-product-image');
          var productName = productWrap.querySelector('.review-product-name');
          var productLink = productWrap.querySelector('.review-product');
          if (productImage && product.image_url) {
            productImage.src = product.image_url;
            productImage.alt = decodeHtmlEntities(product.name || '');
          }
          if (productName) {
            var decodedProductName = decodeHtmlEntities(product.name || '');
            productName.textContent = decodedProductName;
            productName.title = decodedProductName;
          }
          if (productLink && product.name) {
            productLink.setAttribute('aria-label', 'Navigate to ' + decodeHtmlEntities(product.name));
          }
        }
      }
    }

    function rebuildSlides(el, reviews, productMap, templateHtml) {
      var slidesEl = getSlidesEl(el);
      if (!slidesEl || !templateHtml || !reviews.length) return false;

      var isProductPage = Boolean(getProductId(el));
      var parser = document.createElement('ul');
      var fragment = document.createDocumentFragment();

      reviews.forEach(function (review, index) {
        parser.innerHTML = templateHtml;
        var slide = parser.firstElementChild;
        if (!slide) return;
        slide.classList.remove('glide__slide--clone', 'glide__slide--active');
        slide.removeAttribute('data-slide-id');
        slide.setAttribute('aria-label', 'slide ' + (index + 1) + ' out of ' + reviews.length);
        slide.dataset.rbReviewId = String(review.id);
        populateSlide(slide, review, productMap, isProductPage);
        fragment.appendChild(slide);
      });

      slidesEl.innerHTML = '';
      slidesEl.appendChild(fragment);
      fixReviewTextEntities(el);
      /* appendChild empties the fragment — count slides in the track instead */
      return getRealSlides(el).length > 0;
    }

    function prefetchReviewSummary(el) {
      if (el.dataset.rbTotalReviews) {
        updateReviewSummary(el, parseInt(el.dataset.rbTotalReviews, 10));
                return;
              }

      fetch(getReviewsApiUrl(getProductId(el)) + '?per_page=1&page=1')
        .then(function (response) {
          if (!response.ok) throw new Error('summary failed');
          return response.json();
        })
        .then(function (payload) {
          var response = payload && payload.response;
          if (!response) return;
          var total = response.pagination && response.pagination.total
            ? response.pagination.total
            : response.bottomline && response.bottomline.total_review
              ? response.bottomline.total_review
              : 0;
          if (!total) return;
          el.dataset.rbTotalReviews = String(total);
          updateReviewSummary(el, total);
        })
        .catch(function () {});
    }

    function waitForTemplateSlide(callback, attempts) {
      attempts = attempts || 0;
      var templateSlide = root.querySelector('.glide__slide:not(.glide__slide--clone)');
      if (templateSlide) {
        callback(templateSlide);
            return;
      }
      if (attempts >= 80) return;
      window.setTimeout(function () {
        waitForTemplateSlide(callback, attempts + 1);
      }, 250);
    }

    function loadExpandedReviews(el) {
      if (el.dataset.rbReviewsExpanded === '1' || el.dataset.rbReviewsExpanded === 'loading') return;

      waitForTemplateSlide(function (templateSlide) {
        if (el.dataset.rbReviewsExpanded === '1' || el.dataset.rbReviewsExpanded === 'loading') return;

        var templateHtml = templateSlide.outerHTML;
        el.dataset.rbReviewsExpanded = 'loading';

        fetch(getReviewsApiUrl(getProductId(el)) + '?per_page=' + REVIEWS_FETCH_COUNT + '&page=1')
          .then(function (response) {
            if (!response.ok) throw new Error('reviews failed');
            return response.json();
          })
          .then(function (payload) {
            var response = payload && payload.response;
            if (!response || !response.reviews || !response.reviews.length) {
              el.dataset.rbReviewsExpanded = '0';
              return;
            }

            var total = response.pagination && response.pagination.total
              ? response.pagination.total
              : response.bottomline && response.bottomline.total_review
                ? response.bottomline.total_review
                : response.reviews.length;

            var productMap = buildProductMap(response.products);
            if (!rebuildSlides(el, response.reviews, productMap, templateHtml)) {
              el.dataset.rbReviewsExpanded = '0';
              return;
            }

            el._rbSlideCache = {
              templateHtml: templateHtml,
              reviews: response.reviews,
              productMap: productMap,
              total: total,
            };

            el.dataset.rbReviewsExpanded = '1';
            el.dataset.rbTotalReviews = String(total);
            updateReviewSummary(el, total);
            lastLogicalIndex = 0;
            layoutCarousel(el);
            syncScrollbar(el, 0, false);
            /* Remeasure after paint — track width can be 0 on the first un-hide */
            window.setTimeout(function () {
              syncScrollbar(el, lastLogicalIndex, false);
          }, 50);
            window.setTimeout(function () {
              syncScrollbar(el, lastLogicalIndex, false);
            }, 250);
          })
          .catch(function () {
            /* Only clear if we never finished — don't wipe success after a late throw */
            if (el.dataset.rbReviewsExpanded === 'loading') {
              el.dataset.rbReviewsExpanded = '0';
            }
          });
      });
    }

    /* Yotpo's carousel widget sometimes renders nothing — for a product under its
       minimum-reviews setting, and on the homepage whenever the carousel instance
       itself comes back empty from Yotpo. Either way the mount observer above waits
       forever and the heading is left sitting over an empty strip.

       loadExpandedReviews does not actually need Yotpo's markup: it pulls the reviews
       straight from the API and only borrows a rendered slide for its HTML shape. So
       supply that shape ourselves and the normal pipeline runs unchanged. This is the
       same markup rb-reviews-home.js seeds on mobile, which is why mobile keeps
       working when the widget is empty.

       The seeded slide is a blank template, so keep the host hidden until the API has
       filled it — otherwise an empty card flashes for the length of the fetch. If the
       API has nothing either, there genuinely are no reviews: collapse the section. */
    function getFallbackSlideHtml() {
      var star =
        '<span class="yotpo-star-container">' +
        '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="22" height="22" focusable="false">' +
        '<path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#e7721b" fill="#e7721b"></path>' +
        '</svg></span>';
      var stars = '';
      for (var i = 0; i < 5; i++) stars += star;

      return (
        '<li class="glide__slide">' +
          '<div class="reviews-carousel-card-container">' +
            '<div class="yotpo-review">' +
              '<div class="yotpo-header rb-review-card__header">' +
                '<div class="reviews-carousel-card-reviewer-info-container rb-review-card__meta-row">' +
                  '<div class="reviewer-info">' +
                    '<span class="reviewer-display-name"></span>' +
                    '<span class="reviewer-status">Verified Buyer</span>' +
                  '</div>' +
                  '<span class="review-date"></span>' +
                '</div>' +
                '<div class="yotpo-review-stars rb-review-card__stars">' + stars + '</div>' +
              '</div>' +
              '<div class="content-review rb-review-card__body">' +
                '<div class="review-title"></div>' +
                '<div class="review-content"></div>' +
              '</div>' +
              '<div class="reviews-carousel-card-review-product-container rb-review-card__product">' +
                '<a class="review-product" href="#">' +
                  '<img class="review-product-image" src="" alt="" width="40" height="40" loading="lazy" />' +
                  '<span class="review-product-name"></span>' +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }

    function seedFallbackShell(el) {
      /* Our own host, appended alongside Yotpo's — Yotpo rewrites its own node */
      var host = el.querySelector('[data-rb-reviews-shell]');
      if (host) return host;

      host = document.createElement('div');
      host.setAttribute('data-rb-reviews-shell', '1');
      host.setAttribute('data-rb-owns-motion', 'true');
      host.className = 'rb-reviews__native-host';
      host.style.visibility = 'hidden';
      host.innerHTML =
        '<div class="yotpo-reviews-carousel-widget-container rb-reviews__native-shell">' +
          '<div class="carousel-display-wrapper">' +
            '<div class="yotpo-carousel">' +
              '<div class="glide">' +
                '<div class="glide__track" data-glide-el="track">' +
                  '<ul class="glide__slides" data-rb-owns-motion="true">' + getFallbackSlideHtml() + '</ul>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      el.appendChild(host);
      return host;
    }

    /* Yotpo sets data-yotpo-element-loaded once it has rendered, so an instance that is
       loaded and still has no slides has finished and come back empty — seed straight
       away rather than making the reader watch an empty heading for the full timeout.
       The timeout is still the backstop for the case where Yotpo never reports at all. */
    /* The fallback shell ships a .glide__slides of its own, so "has Yotpo rendered?" has to
       ignore anything inside the shell or it would count as proof of itself. */
    function realTrack() {
      var tracks = root.querySelectorAll('.glide__slides');
      for (var i = 0; i < tracks.length; i++) {
        if (!tracks[i].closest('[data-rb-reviews-shell]')) return tracks[i];
      }
      return null;
    }

    function yotpoSettledEmpty() {
      if (realTrack()) return false;
      var instance = root.querySelector('[data-yotpo-instance-id]');
      return Boolean(instance && instance.getAttribute('data-yotpo-element-loaded') === 'true');
    }

    function watchForMissingCarousel() {
      var section = root.closest('.rb-reviews');
      if (!section) return;

      var elapsed = 0;
      var poll = window.setInterval(function () {
        elapsed += 250;
        if (realTrack()) {
          window.clearInterval(poll);
          return;
        }
        if (!yotpoSettledEmpty() && elapsed < 8000) return;
        window.clearInterval(poll);
        startFallback(section);
      }, 250);
    }

    function startFallback(section) {
      var host = seedFallbackShell(root);
      bindCarousel(root);

      /* Product pages render Yotpo later than the homepage does, and it can report loaded
         before it paints any slides. If the real carousel turns up after we seeded, drop the
         shell — leaving both stacks two carousels on top of each other. */
      var yieldWatch = window.setInterval(function () {
        if (!realTrack()) return;
        window.clearInterval(yieldWatch);
        window.clearInterval(reveal);
        host.remove();
        section.classList.remove('rb-reviews--unmounted');
        layoutCarousel(root);
      }, 250);

      var waited = 0;
      var reveal = window.setInterval(function () {
        waited += 250;
        if (root.dataset.rbReviewsExpanded === '1') {
          window.clearInterval(reveal);
          host.style.visibility = '';
          layoutCarousel(root);
          return;
        }
        if (waited >= 8000) {
          window.clearInterval(reveal);
          window.clearInterval(yieldWatch);
          host.remove();
          section.classList.add('rb-reviews--unmounted');
        }
      }, 250);
    }

    function bindCarousel(el) {
      if (!el || el.dataset.rbGlideBound === '1') return;
      if (!el.querySelector('.glide__slides')) return;
      el.dataset.rbGlideBound = '1';

      takeControl(el);
      prefetchReviewSummary(el);
      loadExpandedReviews(el);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            layoutCarousel(el);
          }, 100);
        }).observe(el);
      } else {
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(function () {
            layoutCarousel(el);
          }, 100);
        });
      }
    }

      refreshRbReviewsYotpo();
      if (root.querySelector('.glide__slides')) {
      bindCarousel(root);
        return;
      }
      if (root.dataset.rbMountWatch === '1') return;
      root.dataset.rbMountWatch = '1';
      new MutationObserver(function () {
      if (root.querySelector('.glide__slides')) bindCarousel(root);
      }).observe(root, { childList: true, subtree: true });
      watchForMissingCarousel();
    }

  function initAll() {
    document.querySelectorAll('.rb-reviews__yotpo').forEach(initRbReviewsRoot);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelector('.rb-reviews__yotpo')) return;
    event.target.querySelectorAll('.rb-reviews__yotpo').forEach(function (root) {
      root.dataset.rbReviewsRootInit = '0';
        root.dataset.rbGlideBound = '0';
        root.dataset.rbMountWatch = '0';
      root.dataset.rbCarouselReady = '0';
      root.dataset.rbAutoplay = '0';
      root.dataset.rbReviewsExpanded = '0';
      root.dataset.rbTransformLock = '0';
      root._rbCarouselState = null;
      if (root._rbYotpoKillTimer) {
        window.clearInterval(root._rbYotpoKillTimer);
        root._rbYotpoKillTimer = null;
      }
    });
    initAll();
  });
})();
